export default __webpack_public_path__ + "static/media/logo.942605e8.png";